/**
 * ANQ.UserProfile.API 
 * User Profile Service
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UserCreateResponseDto { 
    userId?: number;
    clientId?: number;
    serviceProviderId?: number;
    message?: string;
    success?: boolean;
    apiKey?: string;
    token?: string;
}